export default "__VITE_ASSET__e7e898b3__"